import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const BastaElavtal = lazy(() => import("@/pages/elavtal/Basta"));

export const Route = createFileRoute("/elavtal/basta")({
  head: () => seoHead("/elavtal/basta", { description: "Vi listar de bästa elavtalen från alla Sveriges elbolag baserat på pris, villkor, kundbetyg och hållbarhet. Hitta avtalet som passar just ditt hem." }),
  component: () => <BastaElavtal />,
});
